import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Please enter your email address below. We will send you an email with instructions for how to reset your password", -1)
const _hoisted_2 = {
  key: 0,
  class: "error-messages"
}
const _hoisted_3 = { class: "field custom-field custom-field_animated" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "custom-field__label-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "custom-field__label" }, "Email address")
], -1)
const _hoisted_5 = { class: "button-container" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Back to Login")
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"stick-to-bottom\"><div class=\"row\"><div class=\"col-6 col-md-3 offset-md-3 text-center\"><a href=\"#\">Terms of use</a></div><div class=\"col-6 col-md-3 text-center\"><a href=\"#\">Privacy policy</a></div></div></div>", 1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "We have sent you an email to reset your password", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Please follow the instructions in the email to reset your password and regain access to your account.", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "If it looks like you have not received the email, please check your spam folder in your mailbox. If you still have not received the email after 15 minutes, please contact us at support@corpservvo.com.", -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", null, [
      _hoisted_1,
      (_ctx.errors)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
              return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("label", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "field__input custom-field__input",
          placeholder: "e.g. your@email.com",
          required: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailAddress) = $event))
        }, null, 512), [
          [_vModelText, _ctx.emailAddress]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: 'login' },
          class: "button button--border"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          href: "#",
          class: "button button--orange",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {_ctx.onSubmit();}, ["prevent"]))
        }, "Send email")
      ]),
      _hoisted_7
    ], 512), [
      [_vShow, !_ctx.emailSent]
    ]),
    _withDirectives(_createElementVNode("div", null, _hoisted_11, 512), [
      [_vShow, _ctx.emailSent]
    ])
  ]))
}